import axiosInstance from "../helpers/axiosInstance"
import S3Client from '../helpers/s3Client'

// Return-receiving video proof. Reuses the same S3 bucket as packing-proof on the
// backend; the `basePath` routes the multipart endpoints to /returns-proof/* and the
// object key is namespaced by the `return_<id>_<random>` prefix.
export const RETURN_PROOF_CONFIG = {
  basePath: '/api/v1/returns-proof',
  newMultipartUploadPath: '/returns-proof/new-multipart-upload',
  generateMultipartUploadPresignedUrlsPath: '/returns-proof/upload-presigned-urls',
  completeMultipartUploadPath: '/returns-proof/complete-upload',
  listFilesWithPrefixPath: '/returns-proof/list',
}

export const listReturnProofFiles = async (prefix) => {
  const s3Client = new S3Client(RETURN_PROOF_CONFIG)
  return s3Client.listFilesWithPrefix(prefix)
}

export const downloadReturnProofVideo = async (path, filename) => {
  const response = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}${path}`, { responseType: 'blob' })
  const blob = response.data
  const blobUrl = window.URL.createObjectURL(blob)

  const link = document.createElement("a")
  link.href = blobUrl
  link.setAttribute("download", filename || path.split("/").pop())
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(blobUrl)

  return true
}
